import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import ChevronLeft from "../../images/icons/chevron-left-black.svg"
import Close from "../../images/close.svg"
import MonthlyOffices from "../../images/icons/icon-monthly-offices.svg"
import "./styles.less"
import { Link, navigate } from "gatsby"

const slots = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
]

const OnboardingMobile = ({
  title,
  className = "",
  onDemand = false,
  locationsPage = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [teamSize, setTeamSize] = useState("0")
  const [step, setStep] = useState(1)
  const [type, setType] = useState("Private office")
  const [searchCity, setSearchCity] = useState("Toronto")

  useEffect(() => {
    setStep(1)
  }, [onDemand])

  useEffect(() => {
    if (teamSize !== "0") {
      goToResults()
    }
  }, [teamSize])

  const goToResults = (spaceType = null) => {
    navigate(
      `/${process.env.GATSBY_ON_DEMAND_SLUG}?current_staff=${teamSize}&location=${searchCity}`
    )
  }

  return (
    <div className={`onboarding-wrapper ${className}`}>
      <div>
        {title && <h1 className={"h2"}>{title}</h1>}
        <Link className={"btn btn-primary"} to={"/locations"}>
          Find workspace
        </Link>
        <Modal fullscreen isOpen={modalOpen}>
          <ModalHeader tag="div" className={`modal-header`}>
            <div className="container d-flex">
              <button
                className={`btn btn-link ${step === 1 && `d-none`} p-0`}
                onClick={() => setStep(1)}
              >
                <img alt="" src={ChevronLeft} />
              </button>
              <button
                className={`btn btn-link ms-auto p-0`}
                onClick={() => setModalOpen(false)}
              >
                <img alt="" src={Close} />
              </button>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="container">
              {step === 1 && (
                <>
                  <h2>What kind of workspace are you looking for?</h2>
                  <Link to={"/locations"}>
                    <div className={`modal-header box d-flex mb-2`}>
                      <img alt="" className={`me-3`} src={MonthlyOffices} />
                      <div className={`d-flex flex-column`}>
                        <h4 className={`mb-0`}>Monthly Office Space</h4>
                        <p>
                          Your own dedicated office space for teams of 1-100.
                        </p>
                      </div>
                    </div>
                  </Link>
                  <div
                    onClick={() => setStep(2)}
                    className={`modal-header box d-flex mb-2`}
                  >
                    <img alt="" className={`me-3`} src={MonthlyOffices} />
                    <div className={`d-flex flex-column`}>
                      <h4 className={`mb-0`}>On-demand Offices</h4>
                      <p>
                        Flexible, private offices on a pay-as-you-need basis.
                      </p>
                    </div>
                  </div>
                  <Link to={"/meeting-rooms"}>
                    <div className={`modal-header box d-flex`}>
                      <img alt="" className={`me-3`} src={MonthlyOffices} />
                      <div className={`d-flex flex-column`}>
                        <h4 className={`mb-0`}>Meeting rooms</h4>
                        <p>
                          From small breakout rooms to large spaces for meetings
                          of up to 16.
                        </p>
                      </div>
                    </div>
                  </Link>
                </>
              )}
              {step === 2 && (
                <>
                  <div
                    className="team-size-wrapper"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      className={`border-0 form-group team-size-selector show mobile`}
                    >
                      <h5>How many people need office space?</h5>
                      <ul>
                        {slots.map((number) => (
                          <li
                            key={number}
                            onClick={() => setTeamSize(number.toString())}
                            className={
                              teamSize === number.toString() ? "active" : ""
                            }
                          >
                            {number}
                          </li>
                        ))}
                        <li
                          className={`long ${
                            teamSize === "21-50" ? "active" : ""
                          }`}
                          onClick={() => setTeamSize("21-50")}
                        >
                          21-50
                        </li>
                        <li
                          className={`long ${
                            teamSize === "51-100" ? "active" : ""
                          }`}
                          onClick={() => setTeamSize("51-100")}
                        >
                          51-100
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  )
}

export default OnboardingMobile
